var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.07a1.95 1.95 0 01.498-.071l5.993-.005h.002c.18 0 .353.032.522.077l-2.519 2.519c-.527.527-1.448.527-1.976 0L8.499 8.069zm5.91 3.935c-.641.642-1.494.995-2.401.995s-1.761-.354-2.402-.995L7.079 9.476a1.968 1.968 0 00-.078.523v2.999c0 .535.208 1.037.586 1.415s.88.585 1.414.585l5.993-.003a2.002 2.002 0 001.999-2v-3c0-.172-.029-.339-.071-.501l-2.512 2.512zM24 12c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s12 5.383 12 12zm-5.007-2.006a3.977 3.977 0 00-1.173-2.83 3.979 3.979 0 00-2.827-1.17h-.004l-5.993.005a4.005 4.005 0 00-3.996 4v2.999c0 1.069.416 2.074 1.172 2.829S7.932 16.998 9 16.998h.003l5.993-.003a4.005 4.005 0 003.997-4v-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c0c13b4abd09435655cda614fa576d58.svg";
export { ForwardRef as ReactComponent };